module.exports = __webpack_public_path__ + "img/horizontal_1_1_6000.7cd75e72.png";